import { sanitize } from "@/lib/dompurify";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip/tooltip";

type Props = {
	label: React.ReactNode;
	tooltipText: string;
};

export const SearchResultTableToolTip = ({ label, tooltipText }: Props) => {
	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<div className="font-normal">{label}</div>
				</TooltipTrigger>
				<TooltipContent>
					<p dangerouslySetInnerHTML={{ __html: sanitize(tooltipText) }} className="text-left font-normal" />
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
};
